import React from 'react';
import Button from './Button';
import { getTalentPoolPathFromStorage } from '../../../utils/talentPoolNavigation';

export default function Navbar({ isLoggedIn, displayName, onLogout, onNavigate }) {
  return (
    <div className="flex items-center justify-between w-full max-w-6xl mx-auto px-6 py-4">
      <div
        className="cursor-pointer font-semibold tracking-widest text-sm"
        onClick={() => onNavigate('/')}
      >
        CREATOR&apos;S ARCH
      </div>

      <div className="bg-[#F3F3F3] rounded-full px-2 py-1 flex items-center gap-2">
        <Button variant="ghost" onClick={() => onNavigate(getTalentPoolPathFromStorage())}>Talent Pool</Button>
        <Button variant="ghost" onClick={() => onNavigate('/learning-certification')}>Academy</Button>
        <Button variant="ghost" onClick={() => onNavigate('/production-sourcing')}>Sourcing</Button>
        <Button variant="ghost" onClick={() => onNavigate('/pitch-upload')}>Pitching</Button>
        <Button variant="ghost" onClick={() => onNavigate('/funding-projects')}>Funding</Button>
        <Button variant="ghost" onClick={() => onNavigate('/chat')}>Chat</Button>
      </div>

      <div className="flex items-center gap-3">
        {isLoggedIn ? (
          <>
            <span className="text-sm text-gray-600">Hi, {displayName}</span>
            <Button variant="outline" className="border-gray-300 text-gray-700 hover:bg-gray-50" onClick={onLogout}>
              Logout
            </Button>
          </>
        ) : (
          <Button
            variant="outline"
            className="border-gray-300 text-gray-700 hover:bg-gray-50"
            onClick={() => onNavigate('/login')}
          >
            Log In
          </Button>
        )}
      </div>
    </div>
  );
}

